import { ComponentPropsWithRef, forwardRef } from 'react';
import styles from './radio.module.css';
import { Label } from '../../../label';
import { cn } from '../../../../utils';

export type RadioProps = ComponentPropsWithRef<'input'> & {
  label?: string;
};

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ disabled, label, className, ...props }, ref) => {
    return (
      <Label
        htmlFor={props.id}
        aria-disabled={disabled}
        className={cn(styles.label, className)}
        variant="body"
      >
        <input
          className={styles.element}
          type="radio"
          ref={ref}
          disabled={disabled}
          aria-disabled={disabled}
          {...props}
        />
        <div className={styles.radio} />
        {label}
      </Label>
    );
  },
);
